import { z } from "zod";
export const leadTypes = ["consumer_waitlist", "seller_waitlist", "pro_application"];
export const leadStatuses = ["new", "contacted", "converted", "discarded"];
export const storeStatuses = ["active", "coming_soon", "waitlist", "hidden"];
export const storeProfileTypes = ["official_store", "authorized_producer", "model_unit", "waitlist"];
export const appRoles = ["admin", "partner", "viewer"];
export const appUserStatuses = ["active", "invited", "suspended", "revoked"];
export const storeUserRoles = ["owner", "manager", "viewer"];
export const storeUserStatuses = ["active", "invited", "suspended", "revoked"];
export const brazilStateSchema = z.string().regex(/^[A-Z]{2}$/);
export const slugSchema = z
    .string()
    .trim()
    .min(3)
    .max(120)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
export const urlSchema = z.string().trim().url().or(z.literal(""));
export const timeSchema = z.string().regex(/^\d{2}:\d{2}$/);
export const leadStatusUpdateSchema = z.object({
    status: z.enum(leadStatuses)
});
export const storeHourSchema = z
    .object({
    dayOfWeek: z.number().int().min(0).max(6),
    opensAt: timeSchema.optional().or(z.literal("")),
    closesAt: timeSchema.optional().or(z.literal("")),
    closed: z.boolean().optional(),
    note: z.string().trim().max(240).optional(),
    sortOrder: z.number().int().min(0).max(20).optional()
})
    .refine((value) => value.closed || (Boolean(value.opensAt) && Boolean(value.closesAt)), {
    message: "Informe abertura e fechamento ou marque como fechado."
});
export const storeHoursUpdateSchema = z.object({
    hours: z.array(storeHourSchema).min(1).max(21)
});
export const partnerStoreProfileSchema = z.object({
    phone: z.string().trim().max(80).optional(),
    whatsapp: z.string().trim().max(80).optional(),
    contactUrl: urlSchema.optional(),
    instagramUrl: urlSchema.optional(),
    orderUrl: urlSchema.optional(),
    mapsUrl: urlSchema.optional(),
    serviceNote: z.string().trim().max(500).optional(),
    dineInAvailable: z.boolean().optional(),
    pickupAvailable: z.boolean().optional(),
    onlineOrderAvailable: z.boolean().optional()
});
export const adminStoreSchema = partnerStoreProfileSchema.extend({
    slug: slugSchema.optional(),
    name: z.string().trim().min(2).max(180).optional(),
    city: z.string().trim().min(2).max(120).optional(),
    state: brazilStateSchema.optional(),
    neighborhood: z.string().trim().max(160).optional(),
    addressLine: z.string().trim().max(240).optional(),
    addressNumber: z.string().trim().max(40).optional(),
    addressComplement: z.string().trim().max(160).optional(),
    postalCode: z.string().trim().max(40).optional(),
    status: z.enum(storeStatuses).optional(),
    profileType: z.enum(storeProfileTypes).optional(),
    publicNote: z.string().trim().max(600).optional(),
    displayOrder: z.number().int().min(0).max(10000).optional(),
    timezone: z.string().trim().max(80).optional()
});
export const adminStoreCreateSchema = adminStoreSchema.required({
    slug: true,
    name: true,
    city: true,
    state: true
});
export const storeUserInviteSchema = z.object({
    email: z.string().trim().email(),
    name: z.string().trim().min(2).max(180),
    role: z.enum(storeUserRoles).default("owner")
});
export const adminPartnerUserCreateSchema = z.object({
    email: z.string().trim().email(),
    name: z.string().trim().min(2).max(180)
});
export const adminPartnerUserUpdateSchema = z.object({
    name: z.string().trim().min(2).max(180).optional(),
    status: z.enum(appUserStatuses).optional()
});
export const adminPartnerUserStoreLinkSchema = z.object({
    storeId: z.string().uuid(),
    role: z.enum(storeUserRoles).default("owner")
});
export const storeProfileTypeLabels = {
    official_store: "Loja autorizada",
    authorized_producer: "Produtor autorizado",
    model_unit: "Unidade modelo",
    waitlist: "Fila aberta"
};
export const dayLabels = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
